var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.BottomLeft.photoList)?_c('div',{staticClass:"item-base"},[_c('el-image',{staticClass:"img",attrs:{"src":'http://'+ _vm.BottomLeft.photoList[0].address,"fit":"cover"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }